﻿// @ts-nocheck
// renderApp - main HTML shell

// ========== Page Rendering =========
async function renderApp() {
  const app = document.getElementById("app");

  // Session-only auth.
  let authed = false;
  currentAuthUser = null;
  currentAuthType = null;
  try {
    const me = await fetch("/api/auth/me", { credentials: "same-origin" });
    authed = me.ok;
    if (me.ok) {
      const meData = await me.json();
      currentAuthUser = meData.user || null;
      currentAuthType = meData.authType || null;
      window.currentCompany = meData.company || null;
      // Apply company theme as soon as we know it (overrides localStorage cache).
      try {
        const allowed = ["tiyb", "light", "dark", "ocean", "sunset"];
        const ct = window.currentCompany?.theme;
        if (ct && allowed.includes(ct)) {
          document.documentElement.setAttribute("data-theme", ct);
          localStorage.setItem("tiyb-theme", ct);
          if (typeof window.__tiybUpdateThemeToggle === "function") {
            window.__tiybUpdateThemeToggle(ct);
          }
        }
      } catch (_) { /* ignore */ }
    }
  } catch (_) { /* ignore */ }

  if (!authed) {
    app.innerHTML = `
      <div class="login-container">
        <div class="login-grid" aria-hidden="true"></div>

        <a href="https://thisisyourbill.com" class="login-logo" aria-label="ThisIsYourBill home">
          <span class="logo-mark">$</span>
          <span class="logo-name">ThisIsYourBill<span class="logo-tld">.com</span></span>
        </a>

        <div class="login-box">
          <h1>Welcome back</h1>
          <div class="subtitle">Sign in to your billing workspace</div>
          <p class="small-text" style="text-align:center; margin-bottom: 1.4rem;">Track time, manage clients, and send clean invoices &mdash; without the bloat.</p>
          <div class="form-group">
            <label>Email</label>
            <input type="email" id="emailInput" placeholder="you@example.com" autocomplete="username" />
          </div>
          <div class="form-group">
            <label>Password</label>
            <input type="password" id="passwordInput" placeholder="Enter your password" autocomplete="current-password" />
          </div>
          <button class="btn btn-primary" id="loginBtn">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/><polyline points="10 17 15 12 10 7"/><line x1="15" y1="12" x2="3" y2="12"/></svg>
            Sign In
          </button>
          <p class="small-text" id="loginError" style="color: #f87171; margin-top: 0.85rem; min-height: 1.25em; text-align: center;"></p>
        </div>

        <a href="https://thisisyourbill.com" class="login-back-link">&larr; Back to home</a>
      </div>
    `;

    const errEl = document.getElementById("loginError");

    document.getElementById("loginBtn").addEventListener("click", async () => {
      errEl.textContent = "";
      const email = document.getElementById("emailInput").value.trim();
      const password = document.getElementById("passwordInput").value;
      if (!email || !password) {
        errEl.textContent = "Email and password required";
        return;
      }
      try {
        const resp = await fetch("/api/auth/login", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "same-origin",
          body: JSON.stringify({ email, password }),
        });
        if (resp.ok) {
          renderApp();
        } else {
          const data = await resp.json().catch(() => ({}));
          errEl.textContent = data.error || "Sign in failed";
        }
      } catch (e) {
        errEl.textContent = "Network error";
      }
    });

    document.getElementById("passwordInput").addEventListener("keydown", (e) => {
      if (e.key === "Enter") document.getElementById("loginBtn").click();
    });

    return;
  }

  const billingModel = currentBillingModel();
  const isServiceBased = billingModel === "service_based";
  const dashboardMeta = getTabMetaForCurrentModel("dashboard");
  const clientsMeta = getTabMetaForCurrentModel("clients");
  const projectsMeta = getTabMetaForCurrentModel("projects");
  const scheduleMeta = getTabMetaForCurrentModel("schedule");
  const toolsMeta = getTabMetaForCurrentModel("tools");
  const reportsMeta = getTabMetaForCurrentModel("reports");
  const settingsMeta = getTabMetaForCurrentModel("settings");
  const adminMeta = getTabMetaForCurrentModel("admin");

  const dashboardMarkup = isServiceBased
    ? `
        <div class="panel" style="margin-bottom: 1rem;">
          <h2>Start Here</h2>
          <p class="small-text" style="margin-bottom: 1rem;">Keep the day simple: add a customer, schedule the visit, move the job forward, then send the invoice.</p>
          <div class="responsive-split-tight" style="margin-bottom: 1rem;">
            <div style="background: var(--bg-secondary); border-radius: 0.5rem; padding: 0.9rem; border: 1px solid var(--border-color);">
              <div class="small-text">Today&apos;s Visits</div>
              <div id="serviceDashboardVisitCount" style="font-size: 1.75rem; font-weight: 700; margin-top: 0.2rem;">0</div>
              <div class="small-text" id="serviceDashboardVisitNote">Loading today&apos;s schedule…</div>
            </div>
            <div style="background: var(--bg-secondary); border-radius: 0.5rem; padding: 0.9rem; border: 1px solid var(--border-color);">
              <div class="small-text">Open Jobs</div>
              <div id="serviceDashboardJobCount" style="font-size: 1.75rem; font-weight: 700; margin-top: 0.2rem;">0</div>
              <div class="small-text" id="serviceDashboardJobNote">Loading open jobs…</div>
            </div>
            <div style="background: var(--bg-secondary); border-radius: 0.5rem; padding: 0.9rem; border: 1px solid var(--border-color);">
              <div class="small-text">Unpaid Invoices</div>
              <div id="serviceDashboardInvoiceCount" style="font-size: 1.75rem; font-weight: 700; margin-top: 0.2rem;">0</div>
              <div class="small-text" id="serviceDashboardInvoiceNote">Loading billing follow-up…</div>
            </div>
          </div>
          <div id="serviceDashboardSetupPanel" style="display:none; margin-bottom: 1rem; background: var(--bg-secondary); border: 1px solid var(--border-color); border-radius: 0.75rem; padding: 1rem;">
            <div style="display:flex; justify-content:space-between; gap:1rem; align-items:flex-start; flex-wrap:wrap;">
              <div>
                <h3 style="margin-bottom: 0.35rem;">Finish Setup</h3>
                <p class="small-text" id="serviceDashboardSetupSummary" style="margin-bottom: 0;">Add the first customer and service so the day-to-day workflow has something to run on.</p>
              </div>
              <button class="btn btn-primary btn-sm" id="serviceDashboardSetupAction">Open Customers</button>
            </div>
            <div class="responsive-split-tight" style="margin-top: 0.85rem;">
              <div style="padding:0.75rem; border-radius:0.5rem; background:var(--bg-primary); border:1px solid var(--border-color);">
                <strong>1. Customer record</strong>
                <div class="small-text" id="serviceDashboardSetupCustomer">Add your first customer with contact details and service address.</div>
              </div>
              <div style="padding:0.75rem; border-radius:0.5rem; background:var(--bg-primary); border:1px solid var(--border-color);">
                <strong>2. Service record</strong>
                <div class="small-text" id="serviceDashboardSetupService">Create the service you will schedule and bill against.</div>
              </div>
            </div>
          </div>
          <div class="responsive-split-tight">
            <div style="background: var(--bg-secondary); border-radius: 0.5rem; padding: 1rem;">
              <h3 style="margin-bottom: 0.35rem;">1. Add a Customer</h3>
              <p class="small-text" style="margin-bottom: 0.75rem;">Save the contact and service address before you schedule work.</p>
              <button class="btn btn-primary btn-sm" onclick="selectTab('clients')">Open ${escapeHtml(clientsMeta.title)}</button>
            </div>
            <div style="background: var(--bg-secondary); border-radius: 0.5rem; padding: 1rem;">
              <h3 style="margin-bottom: 0.35rem;">2. Schedule the Visit</h3>
              <p class="small-text" style="margin-bottom: 0.75rem;">Use the calendar for upcoming stops and same-day schedule changes.</p>
              <button class="btn btn-primary btn-sm" onclick="selectTab('schedule')">Open ${escapeHtml(scheduleMeta.title)}</button>
            </div>
            <div style="background: var(--bg-secondary); border-radius: 0.5rem; padding: 1rem;">
              <h3 style="margin-bottom: 0.35rem;">3. Send the Invoice</h3>
              <p class="small-text" style="margin-bottom: 0.75rem;">Track the job, build the invoice, and keep billing moving without hunting through the app.</p>
              <button class="btn btn-primary btn-sm" onclick="selectTab('tools')">Open ${escapeHtml(toolsMeta.title)}</button>
            </div>
          </div>
        </div>

        <div class="responsive-split" style="margin-bottom: 1rem;">
          <div class="panel">
            <h2>Daily Workflow</h2>
            <p class="small-text" style="margin-bottom: 1rem;">Most teams only need this loop each day.</p>
            <div style="display:grid; gap:0.6rem;">
              <div style="padding:0.85rem; border:1px solid var(--border); border-radius:0.5rem; background:var(--bg-secondary);">
                <strong>Schedule</strong>
                <div class="small-text" id="serviceDashboardScheduleDetail">Review today’s visits and add any new appointments.</div>
              </div>
              <div style="padding:0.85rem; border:1px solid var(--border); border-radius:0.5rem; background:var(--bg-secondary);">
                <strong>Work the jobs</strong>
                <div class="small-text" id="serviceDashboardJobDetail">Move work from backlog to scheduled to done so nothing falls through.</div>
              </div>
              <div style="padding:0.85rem; border:1px solid var(--border); border-radius:0.5rem; background:var(--bg-secondary);">
                <strong>Bill the completed work</strong>
                <div class="small-text" id="serviceDashboardInvoiceDetail">Open Operations to generate invoices and follow up on unpaid work.</div>
              </div>
            </div>
          </div>

          <div class="panel panel-ai">
            <h2>Operations Assistant</h2>
            <p class="small-text" style="margin-bottom: 1rem;">Ask about today’s jobs, scheduling gaps, invoice follow-up, or what should happen next.</p>

            <div class="quick-buttons" id="quickButtons">
              <button class="btn btn-secondary btn-sm" id="quickSummary">Today’s Summary</button>
              <button class="btn btn-secondary btn-sm" id="quickInvoice">Invoice Draft</button>
            </div>

            <div id="aiMessages" class="ai-messages">
              <div class="ai-message assistant">
                <div class="ai-role">Assistant</div>
                <div class="ai-content">I can help you review today’s schedule, find jobs that need attention, and get invoices out faster.</div>
              </div>
            </div>

            <div class="form-group">
              <textarea id="aiInput" rows="3" placeholder="Example: What jobs still need to be scheduled, or which customers should I invoice today?"></textarea>
            </div>

            <div class="actions-row">
              <button class="btn btn-primary" id="aiSendBtn">Ask Assistant</button>
              <div class="small-text" id="aiStatus" style="align-self: center;">Idle</div>
            </div>
          </div>
        </div>
      `
    : `
          <!-- Log Past Work -->
          <div class="panel panel-manual">
            <h2>Add Work Manually</h2>
            <p class="small-text" style="margin-bottom: 1rem;">Use this when you forgot to run the timer or need to enter work from earlier.</p>

            <div class="inputs-row" style="margin-bottom: 0.75rem;">
              <div>
                <label>Date</label>
                <input type="date" id="manualDate" />
              </div>
              <div>
                <label>Time</label>
                <input type="time" id="manualTime" />
              </div>
            </div>
            <div class="inputs-row" style="margin-bottom: 0.75rem;">
              <div>
                <label>Hours</label>
                <input type="number" id="manualHours" placeholder="Hours" step="0.25" min="0.25" />
              </div>
              <div>
                <label>Project</label>
                <select id="manualProjectSelect">
                  <option value="">– Select –</option>
                </select>
              </div>
            </div>
            <div class="form-group">
              <label>Notes (optional)</label>
              <textarea id="manualNotes" placeholder="What did you work on?" rows="2" style="margin-bottom: 0;"></textarea>
              <div class="field-help">A short note helps later when you review reports or create invoices.</div>
            </div>
            <button class="btn btn-primary" id="addManualSessionBtn" style="width: 100%; margin-top: 0.75rem;">Log Work</button>
          </div>

          <!-- Sessions Table -->
          <div class="panel panel-sessions">
            <h2>Today’s Work</h2>
            <p class="small-text" style="margin-bottom: 1rem;">Your recent entries for today appear here so you can spot mistakes quickly.</p>
            <div class="table-wrapper">
              <table id="logTable" class="compact-table">
                <thead>
                  <tr>
                    <th>Project</th>
                    <th>Time</th>
                    <th>Hours</th>
                    <th>Earned</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody></tbody>
              </table>
            </div>
          </div>

          <!-- AI Copilot -->
          <div class="panel panel-ai">
            <h2>Billing Assistant</h2>
            <p class="small-text" style="margin-bottom: 1rem;">Ask plain-language questions about hours, invoices, jobs, or what to do next.</p>

            <div class="quick-buttons" id="quickButtons">
              <button class="btn btn-secondary btn-sm" id="quickSummary">Today’s Summary</button>
              <button class="btn btn-secondary btn-sm" id="quickInvoice">Invoice Draft</button>
            </div>

            <div id="aiMessages" class="ai-messages">
              <div class="ai-message assistant">
                <div class="ai-role">Assistant</div>
                <div class="ai-content">I can help summarize work, prepare invoices, review jobs, or explain what to do next in simple terms.</div>
              </div>
            </div>

            <div class="form-group">
              <textarea id="aiInput" rows="3" placeholder="Example: Which client should I invoice next, or how many hours did we log today?"></textarea>
            </div>

            <div class="actions-row">
              <button class="btn btn-primary" id="aiSendBtn">Ask Assistant</button>
              <div class="small-text" id="aiStatus" style="align-self: center;">Idle</div>
            </div>
          </div>
      `;

  // Main dashboard
  app.innerHTML = `
    <div class="container dashboard-shell">
      <!-- Sidebar -->
      <div class="sidebar">
        <div class="panel brand-panel">
          <div class="brand-row">
            <div class="brand-mark" aria-hidden="true">TYB</div>
            <div class="brand-text">
              <h1 class="brand-title">This is Your Bill</h1>
              <span class="brand-subtitle">Track time. Bill cleanly.</span>
            </div>
          </div>
          <div class="brand-user">
            <span class="brand-user-email" title="${escapeHtml(currentAuthUser?.email || "user")}">${escapeHtml(currentAuthUser?.email || "user")}</span>
            ${currentAuthUser?.role ? `<span class="badge badge-success">${escapeHtml(currentAuthUser.role)}</span>` : ""}
          </div>
          <button class="btn btn-secondary btn-sm brand-signout" onclick="logout()">Sign Out</button>
        </div>
      </div>

      <!-- Main Content -->
      <div class="main">
        <header class="workspace-header" aria-live="polite">
          <h2 id="sectionTitle">${escapeHtml(dashboardMeta.title)}</h2>
          <p id="sectionDescription">${escapeHtml(dashboardMeta.description)}</p>
        </header>

        <!-- Tab Navigation -->
        <div class="tab-nav-shell" id="tabNavShell">
          <button type="button" class="tab-nav-toggle" id="tabNavToggle" aria-label="Open menu" aria-expanded="false" aria-controls="primaryTabNav">
            <span class="tab-nav-toggle-bars" aria-hidden="true"><span></span><span></span><span></span></span>
            <span class="tab-nav-toggle-label">Menu</span>
          </button>
          <nav class="tab-nav" id="primaryTabNav" role="tablist" aria-label="Main sections">
            <button class="tab-btn active" role="tab" aria-selected="true" tabindex="0" data-tab="dashboard"><span class="tab-icon" aria-hidden="true">⏱</span><span class="tab-label">${escapeHtml(dashboardMeta.label || dashboardMeta.title)}</span></button>
            <button class="tab-btn" role="tab" aria-selected="false" tabindex="-1" data-tab="clients"><span class="tab-icon" aria-hidden="true">👥</span><span class="tab-label">${escapeHtml(clientsMeta.label || clientsMeta.title)}</span></button>
            <button class="tab-btn" role="tab" aria-selected="false" tabindex="-1" data-tab="projects"><span class="tab-icon" aria-hidden="true">📁</span><span class="tab-label">${escapeHtml(projectsMeta.label || projectsMeta.title)}</span></button>
            <button class="tab-btn" role="tab" aria-selected="false" tabindex="-1" data-tab="schedule"><span class="tab-icon" aria-hidden="true">📅</span><span class="tab-label">${escapeHtml(scheduleMeta.label || scheduleMeta.title)}</span></button>
            <button class="tab-btn" role="tab" aria-selected="false" tabindex="-1" data-tab="tools"><span class="tab-icon" aria-hidden="true">📄</span><span class="tab-label">${escapeHtml(toolsMeta.label || toolsMeta.title)}</span></button>
            <button class="tab-btn" role="tab" aria-selected="false" tabindex="-1" data-tab="reports"><span class="tab-icon" aria-hidden="true">📊</span><span class="tab-label">${escapeHtml(reportsMeta.label || reportsMeta.title)}</span></button>
            <button class="tab-btn" role="tab" aria-selected="false" tabindex="-1" data-tab="settings"><span class="tab-icon" aria-hidden="true">⚙</span><span class="tab-label">${escapeHtml(settingsMeta.label || settingsMeta.title)}</span></button>
            <button class="tab-btn" role="tab" aria-selected="false" tabindex="-1" id="adminTabBtn" data-tab="admin" style="display:none;"><span class="tab-icon" aria-hidden="true">🛡</span><span class="tab-label">${escapeHtml(adminMeta.label || adminMeta.title)}</span></button>
          </nav>
        </div>

        <!-- Dashboard Tab -->
        <div id="dashboard-tab" class="tab-content" role="tabpanel" aria-hidden="false" style="display: block;">
          ${dashboardMarkup}
        </div>

        <!-- Clients Tab -->
        <div id="clients-tab" class="tab-content" role="tabpanel" aria-hidden="true" style="display: none;">
          <div class="panel panel-clients">
            <h2>${escapeHtml(clientsMeta.title)}</h2>
            <p class="small-text" style="margin-bottom: 1rem;">${escapeHtml(clientsMeta.description)}</p>

            <div data-perm="write" style="background: var(--bg-secondary); padding: 1rem; border-radius: 0.5rem; margin-bottom: 1rem;">
              <h3>${isServiceBased ? "Add a New Customer" : "Add a New Client"}</h3>
              <div class="form-group">
                <input type="text" id="newClientName2" placeholder="${isServiceBased ? "Customer name" : "Client name (person or business)"}" />
              </div>
              <div class="form-group">
                <input type="email" id="newClientEmail2" placeholder="Email (used for invoices)" />
              </div>
              <div class="form-group">
                <input type="tel" id="newClientPhone2" placeholder="Phone" />
              </div>
              <div class="form-group">
                <input type="text" id="newClientAddress2" placeholder="Billing address" />
              </div>
              <div class="form-group">
                <input type="text" id="newClientState2" placeholder="State (e.g., TX)" maxlength="2" />
              </div>
              <div class="form-group">
                <textarea id="newClientNotes2" placeholder="Notes (optional)" rows="2" style="margin-bottom: 0;"></textarea>
              </div>
              <button class="btn btn-primary" id="addClientBtn" style="width: 100%; margin-top: 0.75rem;">${isServiceBased ? "Save Customer" : "Save Client"}</button>
            </div>

            <div id="clientsList" style="max-height: 600px; overflow-y: auto;">
              <p class="small-text">Loading clients...</p>
            </div>
          </div>
        </div>

        <!-- Projects Tab -->
        <div id="projects-tab" class="tab-content" role="tabpanel" aria-hidden="true" style="display: none;">
          <div class="panel panel-projects">
            <h2>${escapeHtml(projectsMeta.title)}</h2>
            <p class="small-text" style="margin-bottom: 1rem;">${isServiceBased ? "Each service belongs to a customer. Pick a customer below, then set the pricing default and service notes." : "Each project belongs to a client. Pick a client below (or add one in the Clients tab), then set the project rate and notes."}</p>

            <div data-perm="write" style="background: var(--bg-secondary); padding: 1rem; border-radius: 0.5rem; margin-bottom: 1rem;">
              <h3>${isServiceBased ? "Add a New Service" : "Add a New Project"}</h3>
              <div class="form-group">
                <label>${isServiceBased ? "Service name" : "Project name"}</label>
                <input type="text" id="newProjectName" placeholder="${isServiceBased ? "e.g., Quarterly Pest Treatment" : "e.g., Spring Pest Service"}" />
              </div>
              <div class="form-group">
                <label>${isServiceBased ? "Customer" : "Client"}</label>
                <select id="newProjectClientSelect">
                  <option value="">— Select a ${isServiceBased ? "customer" : "client"} —</option>
                </select>
                <p class="small-text" style="margin-top: 0.25rem;">Don't see your ${isServiceBased ? "customer" : "client"}? <a href="#" onclick="event.preventDefault(); selectTab('clients');">Add one in ${escapeHtml(clientsMeta.title)} →</a></p>
              </div>
              <div class="inputs-row" style="margin-bottom: 0.75rem;">
                <input type="number" id="newDefaultRate" value="180" placeholder="${isServiceBased ? "Default price / rate" : "Rate/hr"}" />
              </div>
              <div class="form-group">
                <textarea id="newNotes" placeholder="Notes (optional)" rows="2" style="margin-bottom: 0;"></textarea>
              </div>
              <button class="btn btn-primary" id="addProjectBtn" style="width: 100%; margin-top: 0.75rem;">${isServiceBased ? "Save Service" : "Save Project"}</button>
            </div>

            <div id="projectsList" style="max-height: 500px; overflow-y: auto;">
              <p class="small-text">Loading projects...</p>
            </div>
          </div>
        </div>

        <!-- Schedule Tab -->
        <div id="schedule-tab" class="tab-content" role="tabpanel" aria-hidden="true" style="display: none;">
          <div class="panel" style="max-width: 960px;">
            <div class="responsive-header">
              <h2 style="margin: 0;">📆 ${escapeHtml(scheduleMeta.title)}</h2>
              <button class="btn btn-primary btn-sm" id="newApptBtn">+ ${isServiceBased ? "New Visit" : "New Appointment"}</button>
            </div>

            <div class="responsive-split">
              <!-- Calendar -->
              <div>
                <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 0.75rem;">
                  <button class="btn btn-secondary btn-sm" id="schedPrevBtn">‹</button>
                  <strong id="schedMonthLabel" style="font-size: 1rem;"></strong>
                  <button class="btn btn-secondary btn-sm" id="schedNextBtn">›</button>
                </div>
                <div id="schedCalendarGrid" style="display: grid; grid-template-columns: repeat(7, 1fr); gap: 2px; font-size: 0.8rem;"></div>
                <div class="inline-legend">
                  <span><span style="display:inline-block;width:10px;height:10px;border-radius:50%;background:#3b82f6;margin-right:4px;"></span>Scheduled</span>
                  <span><span style="display:inline-block;width:10px;height:10px;border-radius:50%;background:#10b981;margin-right:4px;"></span>Completed</span>
                  <span><span style="display:inline-block;width:10px;height:10px;border-radius:50%;background:#ef4444;margin-right:4px;"></span>Canceled</span>
                </div>
              </div>

              <!-- Day Detail -->
              <div>
                <div id="schedDayDetail" style="background: var(--bg-secondary); border-radius: 0.5rem; padding: 1rem; min-height: 200px;">
                  <p class="small-text" style="text-align: center; margin-top: 2rem;">Click a day to see appointments</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Appointment Modal -->
        <div id="apptModal" style="display:none; position:fixed; inset:0; background:rgba(0,0,0,0.6); z-index:1000; align-items:center; justify-content:center; padding:1rem; overflow-y:auto;">
          <div style="background:var(--bg-primary); border-radius:0.75rem; padding:1.25rem; width:100%; max-width:480px; max-height:calc(100vh - 2rem); overflow-y:auto; box-shadow:0 20px 60px rgba(0,0,0,0.4); -webkit-overflow-scrolling:touch;">
            <h3 id="apptModalTitle" style="margin-bottom:1rem;">New Appointment</h3>
            <input type="hidden" id="apptModalId" />
            <div class="form-group">
              <label>${isServiceBased ? "Customer Name *" : "Client Name *"}</label>
              <input type="text" id="apptClientName" placeholder="e.g., Smith Residence" />
            </div>
            <div class="form-group">
              <label>Service Type *</label>
              <select id="apptServiceType">
                <option value="lawn_mowing">🌿 Lawn Mowing</option>
                <option value="pest_control">🪲 Pest Control</option>
                <option value="tree_trimming">🌳 Tree Trimming</option>
                <option value="irrigation">💧 Irrigation</option>
                <option value="fertilization">🌱 Fertilization</option>
                <option value="other">Other</option>
              </select>
            </div>
            <div class="responsive-split-tight">
              <div class="form-group">
                <label>Date *</label>
                <input type="date" id="apptDate" />
              </div>
              <div class="form-group">
                <label>Time</label>
                <input type="time" id="apptTime" />
              </div>
            </div>
            <div class="responsive-split-tight">
              <div class="form-group">
                <label>Price ($) *</label>
                <input type="number" id="apptPrice" placeholder="0.00" step="0.01" min="0" />
              </div>
              <div class="form-group">
                <label>Assigned To</label>
                <input type="text" id="apptAssignedTo" placeholder="Tech name" />
              </div>
            </div>
            <div class="form-group">
              <label>Notes</label>
              <textarea id="apptNotes" rows="2" placeholder="Address, access instructions, etc."></textarea>
            </div>
            <div class="modal-actions">
              <button class="btn btn-secondary btn-sm" id="apptModalCancelBtn">Cancel</button>
              <button class="btn btn-primary btn-sm" id="apptModalSaveBtn">${isServiceBased ? "Save Visit" : "Save Appointment"}</button>
            </div>
          </div>
        </div>

        <!-- Reports Tab -->
        <div id="reports-tab" class="tab-content" role="tabpanel" aria-hidden="true" style="display: none;">
          <div class="panel panel-reports">
            <h2>${escapeHtml(reportsMeta.title)}</h2>
            <p class="small-text" style="margin-bottom: 1rem;">Choose a month to review totals, client breakdowns, and billable trends.</p>
            
            <div class="form-group">
              <label>Select Month</label>
              <select id="reportMonthSelect" style="width: 100%; padding: 0.5rem; border: 1px solid var(--border); border-radius: 0.375rem;">
                <option value="">– Select month –</option>
              </select>
            </div>

            <div id="monthlyReportContent" style="margin-top: 1rem;"></div>
          </div>
        </div>

        <!-- Tools Tab -->
        <div id="tools-tab" class="tab-content" role="tabpanel" aria-hidden="true" style="display: none;">
          <div class="panel panel-dispatch">
            <h2>📅 ${isServiceBased ? "Job Board" : "Job Board"}</h2>
            <p class="small-text" style="margin-bottom: 1rem;">Track jobs from planned to complete without losing sight of what needs attention.</p>

            <div style="background: var(--bg-secondary); padding: 0.75rem; border-radius: 0.5rem; margin-bottom: 1rem;">
              <div class="form-group"><input type="text" id="newJobTitle" placeholder="Job title" /></div>
              <div class="inputs-row" style="margin-bottom:0.5rem;">
                <input type="text" id="newJobProject" placeholder="${isServiceBased ? "Service (optional)" : "Project (optional)"}" />
                <input type="text" id="newJobClient" placeholder="${isServiceBased ? "Customer (optional)" : "Client (optional)"}" />
              </div>
              <div class="form-group">
                <input type="text" id="newJobAddress" placeholder="Service address (optional)" />
              </div>
              <div class="inputs-row" style="margin-bottom:0.5rem;">
                <input type="date" id="newJobDate" />
                <input type="text" id="newJobAssigned" placeholder="Assigned to" />
              </div>
              <div class="inputs-row" style="margin-bottom:0.5rem;">
                <input type="number" step="0.01" min="0" id="newJobFlatAmount" placeholder="Flat $ per visit (optional)" />
                <select id="newJobRecurrence" title="Recurrence">
                  <option value="none">One-off (no recurrence)</option>
                  <option value="weekly">Weekly</option>
                  <option value="biweekly">Biweekly</option>
                  <option value="monthly">Monthly</option>
                  <option value="quarterly">Quarterly</option>
                </select>
              </div>
              <div class="inputs-row" id="newJobSeasonRow" style="margin-bottom:0.5rem; display:none;">
                <select id="newJobSeasonStart" title="Season start month">
                  <option value="">Season start — any</option>
                  <option value="1">January</option><option value="2">February</option><option value="3">March</option><option value="4">April</option><option value="5">May</option><option value="6">June</option><option value="7">July</option><option value="8">August</option><option value="9">September</option><option value="10">October</option><option value="11">November</option><option value="12">December</option>
                </select>
                <select id="newJobSeasonEnd" title="Season end month">
                  <option value="">Season end — any</option>
                  <option value="1">January</option><option value="2">February</option><option value="3">March</option><option value="4">April</option><option value="5">May</option><option value="6">June</option><option value="7">July</option><option value="8">August</option><option value="9">September</option><option value="10">October</option><option value="11">November</option><option value="12">December</option>
                </select>
              </div>
              <div class="form-group"><textarea id="newJobNotes" rows="2" placeholder="Notes (optional)"></textarea></div>
              <button class="btn btn-primary btn-sm" id="addJobBtn">Save Job</button>
            </div>

            <div id="dispatchBoard"><p class="small-text">Loading jobs...</p></div>
          </div>

          <!-- Invoice Generator -->
          <div class="panel panel-invoice">
            <h2>📄 ${isServiceBased ? "Invoice Builder" : "Invoice Builder"}</h2>
            <p class="small-text" style="margin-bottom: 1rem;">Pick a month and ${isServiceBased ? "customer" : "client"} to build a clean, customer-ready invoice in a few clicks.</p>
            
            <div class="form-group">
              <label>Select Month & ${isServiceBased ? "Customer" : "Client"}</label>
              <div class="responsive-split-3">
                <select id="invoiceMonthSelect" style="padding: 0.5rem; border: 1px solid var(--border); border-radius: 0.375rem;">
                  <option value="">– Select month –</option>
                </select>
                <select id="invoiceClientSelect" style="padding: 0.5rem; border: 1px solid var(--border); border-radius: 0.375rem;">
                  <option value="">– Select ${isServiceBased ? "customer" : "client"} –</option>
                </select>
                <select id="invoiceStateSelect" style="padding: 0.5rem; border: 1px solid var(--border); border-radius: 0.375rem;">
                  <option value="">No tax</option>
                </select>
              </div>
            </div>

            <div class="actions-row">
              <button class="btn btn-primary" id="generateInvoiceBtn">Build Invoice</button>
              <button class="btn btn-secondary" id="downloadInvoiceBtn" style="display: none;">Download PDF</button>
              <div class="small-text" id="invoiceStatus" style="align-self: center;">Ready</div>
            </div>

            <div id="invoicePreview" style="margin-top: 1.5rem; display: none;"></div>
          </div>

          <div class="panel panel-history">
            <h2>🧾 Invoice History</h2>
            <p class="small-text" style="margin-bottom: 1rem;">Saved invoices stay here so you can re-open them quickly later.</p>
            <div id="invoiceHistoryList"><p class="small-text">Loading invoices...</p></div>
          </div>

          <!-- Data Cleanup Tools -->
          <div class="panel panel-cleanup">
            <h2>🧹 Data Cleanup Tools</h2>
            <p class="small-text" style="margin-bottom: 1rem;">Use AI to clean up notes and descriptions before you share or bill from them.</p>
            
            <div id="cleanupStatus" style="display: none; padding: 1rem; background: var(--bg-secondary); border-radius: 0.375rem; margin-bottom: 1rem; border-left: 4px solid var(--primary);">
              <div class="small-text" id="cleanupStatusText"></div>
            </div>

            <div id="cleanupSuggestions" style="margin-bottom: 1rem;"></div>

            <div class="actions-row">
              <button class="btn btn-primary" id="scanDataBtn">Review for Issues</button>
              <div class="small-text" id="cleanupMessage" style="align-self: center;">Ready</div>
            </div>
          </div>
        </div>

        <!-- Settings Tab -->
        <div id="settings-tab" class="tab-content" role="tabpanel" aria-hidden="true" style="display: none;">
          <div class="panel panel-settings">
            <h2>Preferences</h2>
            <div class="form-group">
              <label>Theme</label>
              <select id="themeSelect" onchange="saveTheme()">
                <option value="tiyb">TIYB (default)</option>
                <option value="light">Light</option>
                <option value="dark">Dark</option>
                <option value="ocean">Ocean</option>
                <option value="sunset">Sunset</option>
              </select>
            </div>
            <p class="small-text">Pick the workspace look that feels best for your eyes.</p>

            <div class="form-group">
              <label>Timezone</label>
              <select id="timezoneSelect" onchange="saveTimezone()">
                <option value="America/Chicago">Central Time (CST/CDT)</option>
                <option value="America/Denver">Mountain Time (MST/MDT)</option>
                <option value="America/Los_Angeles">Pacific Time (PST/PDT)</option>
                <option value="America/New_York">Eastern Time (EST/EDT)</option>
                <option value="America/Anchorage">Alaska Time (AKST/AKDT)</option>
                <option value="Pacific/Honolulu">Hawaii Time (HST)</option>
                <option value="UTC">UTC</option>
              </select>
            </div>
            <p class="small-text">Used for time tracking calculations</p>

            <div class="form-group" style="margin-top: 1rem;">
              <label>Billing Model</label>
              <select id="billingModelSelect" onchange="saveBillingModel()">
                <option value="hourly">Hourly Billing</option>
                <option value="service_based">Service-Based Billing</option>
              </select>
              <p class="small-text">Choose the workflow that matches how your company gets paid.</p>
              <p class="small-text" id="billingModelStatus"></p>
            </div>

            <div data-perm="billing" style="margin-top: 1.5rem; padding-top: 1.5rem; border-top: 1px solid var(--border-color);">
              <h3>Payment Processing (Stripe)</h3>
              <div class="form-group">
                <label>Stripe Publishable Key</label>
                <input type="password" id="stripePublishableKey" placeholder="pk_live_..." />
              </div>
              <div class="form-group">
                <label>Stripe Secret Key</label>
                <input type="password" id="stripeSecretKey" placeholder="sk_live_..." />
                <p class="small-text">Saved per company. Secret key is never returned from the API.</p>
              </div>
              <button class="btn btn-primary btn-sm" onclick="saveStripeSettings()">Save Stripe Settings</button>
              <p class="small-text" id="stripeStatus"></p>
            </div>

            <div style="margin-top: 1.5rem; padding-top: 1.5rem; border-top: 1px solid var(--border-color);">
              <h3>Email Invoices</h3>
              <p class="small-text" style="margin-bottom: 0.75rem;">Invoices send through the built-in <strong>ThisIsYourBill mail relay</strong> &mdash; no third-party API key required. The sender used for each invoice is your company's first approved <em>From email</em> (configured in Admin &rarr; Companies). The override below is optional.</p>
              <div class="form-group">
                <label>Override From Email (optional)</label>
                <input type="email" id="fromEmail" placeholder="leave blank to use company default" />
                <p class="small-text">If blank, the server picks the company's first approved sender automatically. If set, it must match one of your company's approved <em>From emails</em> or it will fall back.</p>
              </div>
              <button class="btn btn-primary btn-sm" onclick="saveEmailSettings()">Save Email Settings</button>
              <p class="small-text" id="emailStatus"></p>
            </div>

            <div style="margin-top: 1.5rem; padding-top: 1.5rem; border-top: 1px solid var(--border-color);">
              <h3>US Tax Rates by State</h3>
              <div class="form-group">
                <label>One per line: ST: rate%</label>
                <textarea id="taxRatesByState" rows="6" placeholder="TX: 8.25&#10;CA: 7.25"></textarea>
                <p class="small-text">US only for now. Use 2-letter state code and percent rate.</p>
              </div>
              <button class="btn btn-primary btn-sm" onclick="saveTaxSettings()">Save Tax Settings</button>
              <p class="small-text" id="taxStatus"></p>
            </div>
          </div>
        </div>

        <!-- Admin Tab -->
        <div id="admin-tab" class="tab-content" role="tabpanel" aria-hidden="true" style="display: none;">
          <div class="panel panel-admin" id="adminPanel" style="display:none;">
            <h2>Admin</h2>
            <p class="small-text" style="margin-bottom: 0.75rem;">Manage companies and users.</p>

            <details style="margin-bottom: 1rem;">
              <summary style="cursor: pointer; font-weight: 600;">Companies</summary>
              <div id="adminCompaniesList" style="margin-top: 0.5rem;"></div>
              <div style="background: var(--bg-secondary); padding: 0.75rem; border-radius: 0.5rem; margin-top: 0.75rem;">
                <h3 style="margin-bottom: 0.5rem;">Add company</h3>
                <div class="form-group"><input type="text" id="adminCoSlug" placeholder="slug (e.g. acme)" /></div>
                <div class="form-group"><input type="text" id="adminCoName" placeholder="Display name" /></div>
                <div class="form-group"><input type="text" id="adminCoDomain" placeholder="primary domain (acme.com)" /></div>
                <div class="form-group"><input type="text" id="adminCoFrom" placeholder="from emails (comma-separated)" /></div>
                <div class="form-group">
                  <select id="adminCoBillingModel">
                    <option value="hourly">Hourly Billing</option>
                    <option value="service_based">Service-Based Billing</option>
                  </select>
                </div>
                <button class="btn btn-primary btn-sm" onclick="adminAddCompany()" style="width:100%;">Create company</button>
                <p class="small-text" id="adminCoStatus"></p>
              </div>
            </details>

            <details>
              <summary style="cursor: pointer; font-weight: 600;">Users</summary>
              <div id="adminUsersList" style="margin-top: 0.5rem;"></div>
              <div style="background: var(--bg-secondary); padding: 0.75rem; border-radius: 0.5rem; margin-top: 0.75rem;">
                <h3 style="margin-bottom: 0.5rem;">Add user</h3>
                <div class="form-group"><input type="email" id="adminUserEmail" placeholder="email" /></div>
                <div class="form-group"><input type="password" id="adminUserPassword" placeholder="password (min 8)" /></div>
                <div class="inputs-row" style="margin-bottom: 0.5rem;">
                  <select id="adminUserRole">
                    <option value="member">member</option>
                    <option value="admin">admin</option>
                    <option value="owner">owner</option>
                  </select>
                  <select id="adminUserCompany"><option value="">(no company)</option></select>
                </div>
                <button class="btn btn-primary btn-sm" onclick="adminAddUser()" style="width:100%;">Create user</button>
                <p class="small-text" id="adminUserStatus"></p>
              </div>
            </details>
          </div>
        </div>
      </div>
    </div>
  `;

  // Re-attach all event listeners
  attachEventListeners();
  loadClients().then(() => loadProjects());
  loadSessions().then(() => {
    populateInvoiceMonths();
  });
  loadInvoices();
  loadJobs();
  loadAppointments();
  loadTimezone();
  loadTheme();
  loadBillingModel();
  loadStripeSettings();
  loadTaxSettings();
  loadEmailSettings();
  adminInitPanel();
  applyRoleVisibility();
  setInterval(loadSessions, 10000);
}

function renderServiceDashboardOverview() {
  if (currentBillingModel() !== "service_based") return;

  const setupPanel = document.getElementById("serviceDashboardSetupPanel");
  const setupSummary = document.getElementById("serviceDashboardSetupSummary");
  const setupAction = document.getElementById("serviceDashboardSetupAction");
  const setupCustomer = document.getElementById("serviceDashboardSetupCustomer");
  const setupService = document.getElementById("serviceDashboardSetupService");
  const visitCount = document.getElementById("serviceDashboardVisitCount");
  const visitNote = document.getElementById("serviceDashboardVisitNote");
  const jobCount = document.getElementById("serviceDashboardJobCount");
  const jobNote = document.getElementById("serviceDashboardJobNote");
  const invoiceCount = document.getElementById("serviceDashboardInvoiceCount");
  const invoiceNote = document.getElementById("serviceDashboardInvoiceNote");
  const scheduleDetail = document.getElementById("serviceDashboardScheduleDetail");
  const jobDetail = document.getElementById("serviceDashboardJobDetail");
  const invoiceDetail = document.getElementById("serviceDashboardInvoiceDetail");

  if (!visitCount || !jobCount || !invoiceCount) return;

  const today = new Date().toISOString().slice(0, 10);
  const todaysAppointments = appointments.filter((appointment) => appointment.date === today && appointment.status !== "canceled");
  const openJobs = jobs.filter((job) => job.status !== "done" && job.status !== "canceled");
  const unscheduledJobs = openJobs.filter((job) => !job.scheduledDate && !job.appointmentId);
  const unpaidInvoices = invoices.filter((invoice) => invoice.status !== "paid");
  const sentInvoices = unpaidInvoices.filter((invoice) => invoice.status === "sent");
  const hasCustomers = clients.length > 0;
  const hasServices = projects.length > 0;
  const setupComplete = hasCustomers && hasServices;

  if (setupPanel && setupSummary && setupAction && setupCustomer && setupService) {
    setupPanel.style.display = setupComplete ? "none" : "block";
    setupCustomer.textContent = hasCustomers
      ? `Done: ${clients.length} customer${clients.length === 1 ? "" : "s"} already in your directory.`
      : "Add your first customer with contact details and service address.";
    setupService.textContent = hasServices
      ? `Done: ${projects.length} service${projects.length === 1 ? "" : "s"} ready to schedule.`
      : "Create the service you will schedule and bill against.";

    if (!hasCustomers) {
      setupSummary.textContent = "Start by adding the first customer. Once that exists, add the service you want to schedule and bill.";
      setupAction.textContent = "Open Customers";
      setupAction.onclick = () => selectTab("clients");
    } else if (!hasServices) {
      setupSummary.textContent = "Your customer list is ready. Add the first service so visits, jobs, and billing have something to work from.";
      setupAction.textContent = "Open Services";
      setupAction.onclick = () => selectTab("projects");
    }
  }

  visitCount.textContent = String(todaysAppointments.length);
  jobCount.textContent = String(openJobs.length);
  invoiceCount.textContent = String(unpaidInvoices.length);

  if (visitNote) {
    visitNote.textContent = todaysAppointments.length
      ? `${todaysAppointments.filter((appointment) => appointment.status === "scheduled").length} still scheduled for today`
      : "No visits scheduled yet today";
  }

  if (jobNote) {
    jobNote.textContent = unscheduledJobs.length
      ? `${unscheduledJobs.length} need a date or appointment`
      : "Everything open is already placed in the workflow";
  }

  if (invoiceNote) {
    invoiceNote.textContent = sentInvoices.length
      ? `${sentInvoices.length} already sent and waiting on payment`
      : unpaidInvoices.length
        ? "Draft invoices are waiting for review or send"
        : "No unpaid invoices right now";
  }

  if (scheduleDetail) {
    scheduleDetail.textContent = todaysAppointments.length
      ? `${todaysAppointments.length} visit${todaysAppointments.length === 1 ? "" : "s"} on the calendar today.`
      : "No visits on the calendar yet. Add the first stop for today or the next available date.";
  }

  if (jobDetail) {
    jobDetail.textContent = openJobs.length
      ? `${openJobs.length} active job${openJobs.length === 1 ? "" : "s"} need attention, with ${unscheduledJobs.length} still unscheduled.`
      : "No open jobs right now. New visits will appear here as work is created.";
  }

  if (invoiceDetail) {
    invoiceDetail.textContent = unpaidInvoices.length
      ? `${unpaidInvoices.length} invoice${unpaidInvoices.length === 1 ? "" : "s"} still need payment follow-up.`
      : "No outstanding invoices. Completed work is fully caught up on billing.";
  }
}
